/* eslint-disable no-undef */

import React from 'react';
import { TextInput, Platform, View, } from 'react-native';
// import KeyboardTextInput from '../components/NewKeyBoard';

class CustomTextField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openKeypad: false
    };
  }
  componentDidMount() {
    if (this.props.onRef != null) {
      this.props.onRef(this);
    }
  }

  onChangeText = e => {
    if (this.props.onChangeText) {
      e = e.charAt(0) === ' ' ? '' : e;
      e = e.replace(/  +/g, ' ');
      this.props.onChangeText(e);
    }
  };

  focus() {
    this.textInput.focus();
  }

  blur() {
    this.textInput.blur();
  }

  

  textinputFocus = () => {
    this.setState({ openKeypad: true });
  };

  render() {
    const { measure, onKeyPress } = this.props;
    const checkWidth = () => {
      if (Platform.OS === 'web') {
        if (measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI') {
          return true;
        }
        return false;
      }
      return true;
    };
    return (
      <View>
        {Platform.OS === 'web' ? (
          <View>
            {measure === 'LAPTOP' ||
            measure === 'XXXHDPI' ||
            measure === 'XXHDPI' ? (
              <TextInput
                {...this.props}
                autoCapitalize={this.props.autoCapitalize}
                onKeyPress={onKeyPress}
                onFocus={this.textinputFocus}
                onChangeText={this.onChangeText}
                keyboardType={checkWidth() ? this.props.keyboardType : null}
                // onKeyPress={this.handleKey}
                ref={input => (this.textInput = input)}
                style={[
                  {
                    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
                    fontSize: 14,
                    width:'200%'
                  },
                  Platform.OS === 'web' && {
                    cursor:
                      this.props.editable !== undefined &&
                      !this.props.editable &&
                      'not-allowed'
                  },
                  this.props.style
                ]}
                secureTextEntry={this.props.secureTextEntry}
                autoFocus={this.props.autoFocus}
              />
            ) : (
              // <KeyboardTextInput
              //   {...this.props}
              //   onChangeText={this.onChangeText}
              //   style={this.props.style}
              //   onFocus={this.textinputFocus}
              //   ref={input => (this.textInput = input)}
              // />
              <TextInput
                {...this.props}
                autoFocus={this.props.autoFocus}
                onFocus={this.textinputFocus}
                onKeyPress={onKeyPress}
                onChangeText={this.onChangeText}
                // onKeyPress={this.handleKey}
                keyboardType={checkWidth() ? this.props.keyboardType : null}
                ref={input => (this.textInput = input)}
                style={[
                  {
                    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
                    fontSize: 14
                  },
                  Platform.OS === 'web' && {
                    cursor:
                      this.props.editable !== undefined &&
                      !this.props.editable &&
                      'not-allowed'
                  },
                  this.props.style
                ]}
                secureTextEntry={this.props.secureTextEntry}
              />
            )}
          </View>
        ) : (
          <TextInput
            {...this.props}
            onFocus={this.textinputFocus}
            onChangeText={this.onChangeText}
            onKeyPress={onKeyPress}
            keyboardType={checkWidth() ? this.props.keyboardType : null}
            ref={input => (this.textInput = input)}
            style={[
              {
                fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
                fontSize: 14
              },
              Platform.OS === 'web' && {
                cursor:
                  this.props.editable !== undefined &&
                  !this.props.editable &&
                  'not-allowed'
              },
              this.props.style
            ]}
            secureTextEntry={this.props.secureTextEntry}
          />
        )}
      </View>
    );
  }
}

export default CustomTextField;
